import { apiClient } from '@/shared/services/api';
import type { ApiResponse } from '@/features/auth/services/authApi';

export interface SystemSetting {
  id: string;
  key: string;
  value: string | null;
  label: string;
  description?: string;
  group: string;
  valueType: 'string' | 'number' | 'boolean' | 'percent' | 'account';
  isActive: boolean;
  createdAt: string;
  updatedAt?: string;
}

export const systemSettingsApi = {
  getAll: async (group?: string): Promise<SystemSetting[]> => {
    const params = group ? `?group=${encodeURIComponent(group)}` : '';
    const { data } = await apiClient.get<ApiResponse<SystemSetting[]>>(
      `/system-settings${params}`
    );
    return data.data;
  },

  /**
   * Public-readable subset (currency, locale, …). Available to any authenticated
   * user — does not require system_settings.view.
   */
  getPublic: async (): Promise<SystemSetting[]> => {
    const { data } = await apiClient.get<ApiResponse<SystemSetting[]>>(
      '/system-settings/public'
    );
    return data.data;
  },

  update: async (key: string, value: string): Promise<SystemSetting> => {
    const { data } = await apiClient.put<ApiResponse<SystemSetting>>(
      `/system-settings/${encodeURIComponent(key)}`,
      { value }
    );
    return data.data;
  },
};
